import ContactCTA from '../components/common/ContactCTA';
import SectionHeading from '../components/common/SectionHeading';
import ServiceCard from '../components/common/ServiceCard';
import { services } from '../data/services';

function Services() {
  return (
    <>
      <section className="page-section">
        <div className="container">
          <SectionHeading
            eyebrow="Services"
            title="Industrial repair services"
            text="Focused repair support for industrial gearboxes, hydraulic cylinders, and related mechanical equipment across Canada."
          />
          <div className="card-grid">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        </div>
      </section>
      <ContactCTA />
    </>
  );
}

export default Services;
